import {
    Box,
    Button,
    Grid,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import InputBase from "@mui/material/InputBase";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import "../../../css/global.css"; // Importa el archivo global.css
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import getColumns from "../../../layout/Columns/ColumnsUsuarios";
import { TablePaginateUsers } from "../../../layout/Datagrid/TablePaginateUsers";
import { Icons } from "../../../layout/Icons";
import { queries } from "../../../queries";
import { catalogoList } from "../../../services/CatalogoServices";
import { rolType } from "../../../types/userTypes";
import { userRolEnum } from "../../../types/enumTypes";
import { Add, AddBox, LibraryAdd } from "@mui/icons-material";
import IFrame from "./IFrame";

export interface fechaOrNull {
    fecha: string;
}

export default function EditaUsuarios() {
    const BASEURL = "/inmuebles/comodato";
    const TITULO = "Usuarios Alta";
    const TOKEN = localStorage.getItem("jwtToken");
    const ID_APP = localStorage.getItem("IdApp");
    const { id } = useParams<{ id: string }>();
    const ID_USER = id;

    const navigate = useNavigate();
    return (

        <Grid container>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}>
                <Button variant="contained" color="primary" onClick={() => navigate("/admin/configuracion/usuarios")}>
                    Volver
                </Button>
            </Grid>
            <Grid item xs={12} style={{ flexGrow: 1 }}>
                <IFrame
                    source={
                        "?jwt=" +
                        TOKEN +
                        "&IdApp=" +
                        ID_APP +
                        "&idUsuarioModificado=" +
                        ID_USER
                    }
                    baseURL={String(process.env.REACT_APP_APPLICATION_LOGIN)}
                />
            </Grid>
        </Grid>
    );
}
